// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__T0r8k","left":"InfoRow_left__3gt_e"};